<template>
  <div class="">
    <div class="form-secure-input__container">
      <div
        class="form-group"
        v-for="index in length"
        :key="index"
        :class="[ inputGroupClass ]"
        ref='form-secure__input__group'
      >
        <div class="form-group__panel">
            <input
              class="form-control"
              maxlength="1"
              :type="show ? 'text' : 'password'"
              :aria-label="'Enter digit ' + index"
              :name="'digit-' + index"
              :class="`${inputClasses || ''} ${showError || error !== '' ? 'has-error' : ''}`"
              :style="inputStyles || ''"
              :value="values[index - 1]"
              @input="updateValue(index - 1, $event)"
              @keyup.delete="deleteValue(index - 1)"
            />
        </div>
      </div>
    </div>
    <transition name="slide">
      <span v-show="error" class="form-feedback is-danger">{{ error }}</span>
    </transition>
  </div>
</template>

<script>
/* eslint-disable object-shorthand */
/* eslint-disable func-names */
/* eslint-disable space-before-function-paren */
/* eslint-disable arrow-parens */
import themeSetupMixin from '@/mixins/theme';
import inputMixin from '../input.mixin';

export default {
  props: {
    /**
     * if `true`, allow user to see the input values
    */
    show: {
      type: Boolean,
      default: false,
    },
    /**
     * length of inputs
    */
    length: {
      type: Number,
      default: 6,
      validator: value => value >= 4,
    },
    /**
     * if `true`, reset all input value
    */
    reset: {
      type: Boolean,
      default: false,
    },
    /**
     * if it is not empty, show error
    */
    error: {
      type: String,
      default: '',
    },
    /**
     * Custom input validator
    */
    validator: {
      type: Function,
      default: null,
    },
    /**
     * ClassNames for input group
    */
    inputGroupClass: {
      type: String,
      default: '',
    },
    /**
     * ClassNames for input
    */
    inputClasses: {
      type: String,
      default: '',
    },
    /**
     * Inline Styles for input
    */
    inputStyles: {
      type: String,
      default: '',
    },
  },
  mixins: [themeSetupMixin, inputMixin],
  /**
   * WATCH
   */
  watch: {
    /**
     * Watches for changes when Reset is invoked from parent component
     * and resets the values in the secure input boxes
     * @function reset
     * @return {void}
     */
    reset() {
      this.values = Array(this.length).fill('');
      const inputGroup = this.$refs['form-secure__input__group'][0];
      const inputControl = inputGroup.querySelector('.form-control');
      inputControl.focus();
      this.showError = false;
      this.$emit('reset', false);
      this.$emit('input', '');
    },
  },
  data() {
    return {
      values: Array(this.length).fill(''),
      showError: false,
    };
  },
  /**
   * METHODS
   */
  methods: {
    /**
     * Validates the value being inputted and emits input back to parent
     * @function updateValue
     * @param {Number} index - Index of the active input box
     * @param {Object} event - The Native browser Event.
     * @return {void}
     */
    updateValue(index, event) {
      this.values[index] = event.target.value;
      this.validate();
      if (this.values[index].length && index < this.length - 1) {
        const nextIndex = index + 1;
        const inputGroup = this.$refs['form-secure__input__group'][nextIndex];
        const inputControl = inputGroup.querySelector('.form-control');
        inputControl.focus();
      }
      this.$emit('input', this.values.join(''));
    },
    /**
     *  Handles on delete event and validates
     * @function deleteValue
     * @param {Number} index - Index of the active input box
     * @param {Object} event - The Native update Event.
     * @return {void}
     */
    deleteValue(index) {
      if (!this.values[index] && index > 0) {
        const prevIndex = index - 1;
        const inputGroup = this.$refs['form-secure__input__group'][prevIndex];
        const inputControl = inputGroup.querySelector('.form-control');
        inputControl.focus();
      } else {
        this.values[index] = '';
      }
      this.validate();
    },
    /**
     *  Validate Function passed as a Prop
     * @function deleteValue
     * @return {void}
     */
    validate() {
      if (this.validator !== null) {
        const value = this.values.join('').replace(/ /g, '');
        this.showError = !this.validator(value);
      }
    },
  },
};
</script>

<style scoped lang="scss">

.form-secure-input__container {
  display:flex;
  .form-control {
    max-width: 73px;
    max-height: 73px;
    width: 10vh;
    height: 10vh;
    display: inline-block;
    border: 1px solid var(--primary-30);
    border-radius: 4px;
    margin-right: 12px;
    color: var(--text-30);
    font-size: 14px;
    text-align: center;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    [type=number] {
      -moz-appearance: textfield;
      /* Firefox */
    }

    &:focus {
      outline: none;
      border: 2px solid var(--brand-main);
    }


    &.has-error {
      border-color: var(--failed-20);

      &:focus,
      &:active {
        border-color: var(--failed-20);
      }

      &::placeholder {
        color: var(--failed-20);
      }
    }
  }

}

</style>
